export default __webpack_public_path__ + "static/media/logo-eoa-main.d6c2d001.png";